import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
}

export type StageOrderUpdateInput = {
    id: string,
    order: number,
}

interface Variables {
    stages: StageOrderUpdateInput[]
}

export const UPDATE_STAGES_ORDER: TypedDocumentNode<Result, Variables> = gql`
    mutation UpdateStagesOrder($stages: [StageOrderUpdateInput]){
        updateStageOrder(stages: $stages)
    }       
`
